import * as fromDatatype from '../datatype-library/index';

export interface bl_sfa_sales_lead_file_upload_line_RowInterface {
 
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid  : fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  data_line_json : fromDatatype.JsonDatatypeInterface;
  sales_lead_hdr_guid : fromDatatype.GuidDataFieldInterface;
  sales_lead_hdr_status : fromDatatype.VarcharDatatypeInterface;
  sales_lead_hdr_message : fromDatatype.TextDatatypeInterface;
  contact_hdr_guid : fromDatatype.GuidDataFieldInterface;
  contact_hdr_status : fromDatatype.VarcharDatatypeInterface;
  contact_hdr_message : fromDatatype.TextDatatypeInterface;
  contact_key_guid : fromDatatype.GuidDataFieldInterface;
  contact_key_status : fromDatatype.VarcharDatatypeInterface;
  contact_key_message : fromDatatype.TextDatatypeInterface;
  ucc_outbound_task_guid : fromDatatype.GuidDataFieldInterface;
  ucc_outbound_task_status : fromDatatype.VarcharDatatypeInterface;
  ucc_outbound_task_message : fromDatatype.TextDatatypeInterface;
  ucc_outbound_task_queue_guid : fromDatatype.GuidDataFieldInterface;
  ucc_outbound_task_queue_status : fromDatatype.VarcharDatatypeInterface;
  ucc_outbound_task_queue_message : fromDatatype.TextDatatypeInterface;
  is_duplicated : boolean;
  error_message : fromDatatype.TextDatatypeInterface;
  app_file_item_guid : fromDatatype.GuidDataFieldInterface;
  description : fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status : fromDatatype.StatusDataFieldInterface
  revision : fromDatatype.GuidDataFieldInterface
  vrsn : fromDatatype.VarcharDatatypeInterface;
}

export class bl_sfa_sales_lead_file_upload_line_RowClass implements bl_sfa_sales_lead_file_upload_line_RowInterface {
  
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid  : fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  data_line_json : fromDatatype.JsonDatatypeInterface;
  sales_lead_hdr_guid : fromDatatype.GuidDataFieldInterface;
  sales_lead_hdr_status : fromDatatype.VarcharDatatypeInterface;
  sales_lead_hdr_message : fromDatatype.TextDatatypeInterface;
  contact_hdr_guid : fromDatatype.GuidDataFieldInterface;
  contact_hdr_status : fromDatatype.VarcharDatatypeInterface;
  contact_hdr_message : fromDatatype.TextDatatypeInterface;
  contact_key_guid : fromDatatype.GuidDataFieldInterface;
  contact_key_status : fromDatatype.VarcharDatatypeInterface;
  contact_key_message : fromDatatype.TextDatatypeInterface;
  ucc_outbound_task_guid : fromDatatype.GuidDataFieldInterface;
  ucc_outbound_task_status : fromDatatype.VarcharDatatypeInterface;
  ucc_outbound_task_message : fromDatatype.TextDatatypeInterface;
  ucc_outbound_task_queue_guid : fromDatatype.GuidDataFieldInterface;
  ucc_outbound_task_queue_status : fromDatatype.VarcharDatatypeInterface;
  ucc_outbound_task_queue_message : fromDatatype.TextDatatypeInterface;
  is_duplicated : boolean;
  error_message : fromDatatype.TextDatatypeInterface;
  app_file_item_guid : fromDatatype.GuidDataFieldInterface;
  description : fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status : fromDatatype.StatusDataFieldInterface
  revision : fromDatatype.GuidDataFieldInterface
  vrsn : fromDatatype.VarcharDatatypeInterface;

}
